import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MediaSelectComponent } from './media-select.component';
import { FilesizePipe } from '../filesize.pipe';
import { SharedModule } from '../../shared.module';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SharedModule
  ],
  declarations: [
    MediaSelectComponent
  ],
  exports: [
    MediaSelectComponent
  ]
})
export class MediaSelectModule { }
